import { useCallback, useEffect, useState } from 'preact/hooks'
import { createPortal } from 'preact/compat'
import { useSearchspringContext } from '../fetchers/provider'
import { useBeaconLogImpressions, useBeaconLogRender } from '../hooks/useBeaconAnalytics'
import { ResultsCard } from './ResultCard'
import Icon from '@/components/snippets/icon/icon'
import { dataTracker } from '@/components/snippets/analytics/analytics'

export function CarouselControl({ role, icon }) {
  return (
    <button data-role={role} class="btn btn-icon btn-md btn-inline btn-outline-black justify-center">
      <Icon id={icon} className="w-5 h-5" />
    </button>
  )
}

export function CarouselResults({ className, hideControlsOnMobile, controlClass, toggleControls, maxResults }) {
  const { results } = useSearchspringContext()
  const [node, setNode] = useState()
  const displayFlickityControllers = !(toggleControls === 'true')

  // Limit results to the specified maximum if provided
  const displayResults = maxResults && results?.results ? results.results.slice(0, maxResults) : results?.results

  const SliderPortal = useCallback(
    ({ children }) => {
      if (!node) return children
      const target = node.querySelector('.flickity-slider')
      return createPortal(children, target)
    },
    [node]
  )

  useEffect(() => {
    if (!node) return
    node.initialiseFlickity()
  }, [node, results])

  // Analytics related hooks
  useBeaconLogRender()
  useBeaconLogImpressions(node)

  if (displayResults?.length === 0) return null
  if (node) node.flickity.reloadCells()

  return (
    <x-flickity ref={setNode}>
      {displayFlickityControllers && (
        <div
          data-role="controller"
          class={`${hideControlsOnMobile ? 'hidden md:flex' : 'flex'} flex-row justify-end gap-2 pb-10 ${
            controlClass || ''
          }`}
        >
          <CarouselControl role="previous" icon="chevron-left" />
          <CarouselControl role="next" icon="chevron-right" />
        </div>
      )}
      {/* display results */}
      <div data-role="container" class="md:flex [&.flickity-enabled]:block">
        <SliderPortal>
          {displayResults?.map((result, index) => (
            <div className={className}>
              <ResultsCard
                wishlist={{
                  type: 'none'
                }}
                result={result}
                key={results.handle}
                index={index}
                className="wk-wishlist-button-target"
              />
            </div>
          ))}
        </SliderPortal>
      </div>
      {displayFlickityControllers && (
        <div data-role="progress-bar" class="mt-8 h-1 w-full bg-neutrals-light-grey">
          <div class="h-full w-[--progress] bg-primary-black transition-all duration-200"></div>
        </div>
      )}
    </x-flickity>
  )
}
